angular.module('stack.common.utility.services.InterceptorService', [
  'global'
])

/**
 * The InterceptorService intercepts http traffic and attempts
 * to normalize the handling of status codes in relation to
 * the execution of success and error callbacks. The backend
 * API provides nested status codes which can result in the
 * firing of the success method when an error has truly occurred.
 * This behavior is not desirable and can result in messy and
 * complex handlers. To rectify the issue, through the use of
 * promises, the nested response code is parsed and is either
 * resolved or rejected triggering the appropriate success or
 * error method on the calling method.
 *
 * @class InterceptorService
 * @constructor
 * @module stack.common.utility.services.InterceptorService
 */
.factory('InterceptorService', [
  '$q',
  '$rootScope',
  function ($q, $rootScope) {
    'use strict';

    var service = {
      /**
       * Method maps nested status codes to the
       * root response object.
       *
       * @param {Object} response - $http response object
       * @return {Object} Potentially modified response object
       */
      normalizeStatusCode: function normalizeStatusCode(response) {
        if (!_.has(response.data, 'result')) {
          response.data.result = response.status;
        }

        response.status = parseInt(response.data.result, 10);

        return response;
      },

      /**
       * Method examines the nested data property on
       * the response object for the loginerror property.
       * When detected, the status code on the response
       * object is updated accordingly.
       *
       * @param {Object} response - $http response object
       * @return {Object} Potentially modified response object
       */
      normalizeAuthenticationFailure: function normalizeAuthenticationFailure(response) {
        if (_.has(response.data, 'loginerror') && response.data.loginerror) {
          response.data.result = 403;
          response.status = response.data.result;
        }

        return response;
      },

      /**
       * Method intercepts and examines the http response object.
       *
       * @param {Object} respons - $http response object
       * @return {Promise<Object>} updated response
       */
      response: function response(respons) {
        var d = $q.defer();
        var ret;

        // The response object is defined and contains a data property.
        if (angular.isDefined(response) && _.has(response, 'data')) {
          // The data property is an object and not a template.
          if (angular.isObject(response.data)) {
            // Normalize status code.
            ret = service.normalizeStatusCode(respons);

            // Normalize authentication failure.
            ret = service.normalizeAuthenticationFailure(respons);

            // Resolve or reject the response based upon the status code.
            if (_.includes([200, 201], response.status)) {
              d.resolve(ret);
            } else if (_.includes([400, 401, 403, 404, 500], response.status)) {
              d.reject(ret);
            } else {
              d.resolve(ret);
            }
          } else {
            // Allow template requests to pass through.
            d.resolve(ret);
          }
        }

        return d.promise;
      },

      /**
       * Method listens globally for response errors.
       *
       * @param {Object} rejection - Error object
       */
      responseError: function responseError(rejection) {
        var message;

        // System failure.
        if (rejection.status === 500) {
          message = rejection.status + ' (' + rejection.statusText + ')';
          $rootScope.$broadcast('critical:danger', { error: message });
          $rootScope.$broadcast('applicationloader:hide');
        }

        // Always hide the application loader.
        $rootScope.$broadcast('applicationloader:hide');

        // Return the promise rejection.
        return $q.reject(rejection);
      }
    };

    return service;
  }
]);
